import { useSplitEnabled } from '@buffer-mono/features'
import { usePlan } from '~publish/contexts/AccountContext'

/**
 * This is for the override to force disable link shortening for free users depending on split configuration
 * We should remove it after the changes are finalized
 */
export function useLinkShorteningDisabledOverride(): boolean {
  const split = useSplitEnabled('link-shortening-off-for-free')
  const plan = usePlan()

  if (split.isReady && split.isEnabled && plan.id === 'free') {
    return true
  }

  return false
}
